import React, { useState } from 'react';
import Problema from '../../../../assets/images/sinal.gif';
import Sinal from '../../../../assets/images/wifiman.png';
import Card from 'react-bootstrap/Card';

import 'bootstrap/dist/css/bootstrap.min.css';

function Ferramentas() {


  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Solução de problemas - Ferramentas</h1>
            <img src={Problema} alt='problema' className='mb-3 mt-2' />
            <Card className="text-center">
              <Card.Header><div className="opcoes">Ferramentas para análise de redes Wi-Fi</div></Card.Header>
              <Card.Body>
                {/* <Card.Title>Coleta de Informações e Análise do Ambiente</Card.Title> */}
                <Card.Text>
                  <div className='opcoes'>
                    <div>
                    <strong>1. WiFiman: </strong> Desenvolvido pela Ubiquiti, WiFiman é uma 
                    ferramenta intuitiva que oferece análise detalhada da rede Wi-Fi, incluindo 
                    a intensidade do sinal e a detecção de zonas mortas.
                    </div>
                    <div>
                    <strong>2. WiFi Analyzer: </strong>  WiFi Analyzer é uma ferramenta 
                    popular para analisar redes Wi-Fi, 
                    mostrando canais sobrecarregados e intensidade do sinal em diferentes áreas.

                    </div>
                    <div>
                    <strong>3. inSSIDer: </strong> 
                    inSSIDer é uma ferramenta de análise Wi-Fi que ajuda a otimizar a rede, identificando pontos fracos e interferências.
                    </div>
                  </div>
                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer className="text-muted">
              
              </Card.Footer>
            </Card>

          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={Sinal} alt="Current slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Ferramentas;
